module.exports = __webpack_public_path__ + "static/img/hello.66d6ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hello.png
// module id = 8aq8
// module chunks = 2